<div class="workload-item"
     [ngClass]="{ 'animated-tile': scaleTile }"
     (mouseover)="mouseOverTile()"
     (contextmenu)="instrumentRightClick()"
     (mouseleave)="unfocusTile()">
    <a id="{{ elementId }}"
       href="{{ workload.Url }}"
       rel="noopener"
       ohpDefaultLinkTarget
       (focus)="mouseOverTile()"
       (blur)="unfocusTile()"
       (click)="onTileClick($event)"
       [attr.aria-label]="ariaLabel"
       class="o365cs-base workload-item__link ms-bgc-w-h ms-bgc-w-a ms-bgc-w-f"
       data-clicklog="custom"
       [ngClass]="{ 'workload-item--provisioning': !isProvisioned,
                    'workload-item--provisioned workload-item--fluent--provisioned': isProvisioned,
                    'ms-bgc-w': setWhiteBackground }"
       [ohpFocusOnLoad]="focusOnLoad"
       [detectChanges]="true"
       [ohpPreload]="preloadPath">

        <!-- If the shell passes down a font icon css class, we use that to render the icon -->
        <!-- Otherwise we use the icon font glyph name sent in workload data to do the css mapping -->
        <span class="workload-item__icon"
              [ngClass]="{ 'workload-item__icon--3rd-party-image': workload.IsThirdParty }"
              [ngStyle]="{ 'color': !isProvisioned ? '' : (appColor || workload.Color) }">
            <ohp-icon-font *ngIf="!workload.ThirdPartyIcon || !iconLoaded"
                           [iconFontCssClass]="workload.IconUnicodeCodepointCssClass + ' app-tile-icon--small'"
                           [iconFontName]="workload.IconFont"
                           [isThirdParty]="workload.IsThirdParty">
            </ohp-icon-font>
            <img *ngIf="workload.ThirdPartyIcon"
                 [hidden]="!iconLoaded"
                 class="workload-item__icon--image"
                 [src]="workload.ThirdPartyIcon"
                 aria-hidden="true"
                 [attr.alt]="thirdPartyIconAriaLabel"
                 (load)="onIconLoad()"
                 (error)="onIconError()"/>
        </span>
        <div id="{{ elementId }}_text"
             class="workload-item__name"
             [ngStyle]="{ 'color': showHover && isProvisioned ? appColor || workload.Color : '' }">
            <div class="workload-item__text"
                 [ngClass]="{ 'workload-item__text--third-party': workload.IsThirdParty, 'ms-fcl-nd': !showHover }"
                 [title]="workload.Text">
                {{ workload.Text }}
                <span *ngIf="!isProvisioned"
                      class="workload-item-text--provisioning--fluent">
                    {{ provisioningText }}
                </span>
            </div>
        </div>
        <span *ngIf="pinnedApp"
                class="workload-item__unpin ms-fcl-nd ms-fcl-tp-h ms-fcl-tp-f ms-bgc-g40-h ms-bgc-g40-f"
                (click)="unpinApp($event)"
                (keyup.enter)="unpinApp($event)"
                (keyup.space)="unpinApp($event)"
                (focus)="mouseOverTile()"
                (blur)="unfocusTile()"
                [attr.aria-label]="removeAppAriaLabel"
                [title]="removeAppAriaLabel"
                role="button"
                tabindex="0">
                <ohp-icon-font iconFontName="X"></ohp-icon-font>
        </span>
    </a>
</div>
